var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThankYou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#E6E5EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 27V43.7688L44.9798 70.9202L42.1515 68.1319L20 43.7688V27H39.7929L44.9798 32.0853L50.2071 27H70Z",
    fill: "url(#paint0_linear_2484_6840)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2484_6840",
    x1: 62.2306,
    y1: 19.234,
    x2: 27.7474,
    y2: 53.7323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#293DED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#3E3DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#753DB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#CC3E7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F23F62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYou);
export default __webpack_public_path__ + "static/media/thank-you.471def45499ed462768e31971766989c.svg";
export { ForwardRef as ReactComponent };